import multiSort from '../components/../utils/arrayMultipleSort'
import store from '../store'
import DSI from './tableLayoutIndexes'

export const GROUPING = {
   PARCEL: 'P',
   OWNER: 'O'
 }

export const SORT = {
  ID: GROUPING.PARCEL + 0,
  PARCEL: GROUPING.PARCEL + 1,
  OWNER: GROUPING.OWNER + 2
}

const sortBy = {
  [SORT.ID]: ['id'],
  [SORT.PARCEL]: [1, 3, 4],
  [SORT.OWNER]: ['n', 'a']
}

export const isSortByParcel = (sorted) => sorted[0] === GROUPING.PARCEL

export const sort = (array, sorted) => array.sort(multiSort(...sortBy[sorted]))

export const VIEW = {
  NONE: -1,
  FULL: 0,
  SUMMARY: 1,
  EXPORT: 2,
  USER: 3
}

export const getViewName = view => {
  switch (view) {
    case VIEW.SUMMARY:
      return 'Základní údaje'
    case VIEW.FULL:
      return 'Všechny údaje'
    case VIEW.EXPORT:
      return 'Informace o pozemku'
    default:
      return null
  }
}

export const USER_VIEW_PREFIX = 'U'

const defaultMasks = {
  [VIEW.NONE]: '1',
  [VIEW.FULL]: `0,1,102,5-${DSI.BD_MAX}`,
  [VIEW.SUMMARY]: `1,102,6,12,${DSI.TAGS},${DSI.OWNER_NAME}-${DSI.SHARE},${DSI.OWNER_NEG_STATE}`,
  [VIEW.EXPORT]: `0,1,102,5-${DSI.SHARE},${DSI.BPEJ_AREA}`
}

export const getMask = (sorted, view, addScrollColumn = true) => {
  let mask
  if (view[0] === USER_VIEW_PREFIX) {
    const state = store.getState()
    let uSets = state.tableLayout.userSettings.views[view]
    if (!uSets) {
      const eView = view.charAt(1) === GROUPING.PARCEL
        ? view.replace(GROUPING.PARCEL, GROUPING.OWNER)
        : view.replace(GROUPING.OWNER, GROUPING.PARCEL)
      uSets = state.tableLayout.userSettings.views[eView]
    }
    mask = uSets ? uSets.mask : defaultMasks[VIEW.SUMMARY]
  } else {
    mask = defaultMasks[view]
  }
  const parts = mask.split(',')
  if (addScrollColumn) {
    parts.push(DSI.SCROLL_COLUMN.toString())
  }
  let result = []
  for (let i = 0; i < parts.length; i++) {
    if (parts[i].indexOf('-') !== -1) {
      const subparts = parts[i].split('-')
      for (let j = Number(subparts[0]); j <= Number(subparts[1]); j++) {
        if (result.indexOf(j) === -1) {
          result.push(j)
        }
      }
    }
    else {
      if (result.indexOf(parts[i] === -1)) {
        result.push(Number(parts[i]))
      }
    }
  }
  return result
}

export const getNoRowSpanMask = (mask, noRowSpan = DSI.TABLE_BY_PARCEL_NO_ROWSPAN_COL) => {
  let result = []
  for (let i = 0; i < mask.length; i++) {
    if (noRowSpan.indexOf(mask[i]) !== -1) {
      result.push(mask[i])
    }
  }
  return result
}



// WEBPACK FOOTER //
// ./src/config/tableLayout.js